import { Role } from '@/constants/users/roles'

export interface INavigationRoute {
  name: string;
  displayName: string;
  meta: { icon: string };
  children?: INavigationRoute[];
  allowedRoles?: (keyof typeof Role)[];
}

const routes = (): INavigationRoute[] => [
  {
    name: 'users',
    displayName: 'menu.users',
    meta: {
      icon: 'group',
    },
    allowedRoles: ['Administrator', 'SuperAdministrator'],
  },
  {
    name: 'game',
    displayName: 'menu.game',
    meta: {
      icon: 'games',
    },
    allowedRoles: ['Administrator', 'SuperAdministrator'],
  },
  {
    name: 'news',
    displayName: 'Новости',
    meta: {
      icon: 'settings',
    },
  },
  {
    name: 'settings',
    displayName: 'menu.settings',
    meta: {
      icon: 'settings',
    },
  },
  {
    name: 'logs',
    displayName: 'menu.logs',
    meta: {
      icon: 'history',
    },
    allowedRoles: ['Administrator', 'SuperAdministrator'],
  },
];

export default {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: routes(),
};
